import Consultorio, { FinderConsultorios, RetornoConsultorio } from 'Interface/Consultorios';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Consultorios';

const url = '/consultorios';

const apiExtendida = api.enhanceEndpoints({
    addTagTypes: [tag],
}).injectEndpoints({
    endpoints: construtor => ({
        recuperarConsultorios: construtor.query<FinderConsultorios, Parametros | void>({
            query: (params) => `${url}?${paramsParaString(params)}`,
            providesTags: (resultado) => resultado?.consultorios
                ? [
                    ...resultado.consultorios.map(({ id }) => ({ type: tag, id } as const)),
                    { type: tag, id: 'LISTA' },
                ]
                : [{ type: tag, id: 'LISTA' }],
        }),
        recuperarConsultorio: construtor.query<RetornoConsultorio, string | number | Parametros>({
            query: params => {
                let id: number;
                let query: Parametros = {};

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                    query = paramsParaString(params);
                }

                return `${url}/${id}?${query}`;
            },
            providesTags: (resultado, erro, params) => {
                let id: number;

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                }

                return [{ type: tag, id }];
            },
        }),
        adicionarConsultorio: construtor.mutation<Consultorio, Partial<Consultorio>>({
            query: (dados) => ({ url: url, method: 'POST', body: formData(dados, 'POST') }),
            invalidatesTags: (resultado, erro) => !erro ? [{ type: tag, id: 'LISTA' }] : [],
        }),
        editarConsultorio: construtor.mutation<Consultorio, Partial<Consultorio> & Pick<Consultorio, 'id'>>({
            query: ({ id, ...dados }) => ({ url: `${url}/${id}`, method: 'POST', body: formData(dados, 'PUT') }),
            invalidatesTags: (resultado, erro, { id }) => !erro ? [{ type: tag, id }] : [],
        }),
    }),
    overrideExisting: false,
});

export const {
    useRecuperarConsultoriosQuery,
    useRecuperarConsultorioQuery,
    useAdicionarConsultorioMutation,
    useEditarConsultorioMutation,
} = apiExtendida;
